import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../Guards/AuthGuard';
import { CustomersListComponent } from './customers-list/customers-list.component';
import { CustomersAddComponent } from './customers-add/customers-add.component';

const routes: Routes = [
  { path: '', component: CustomersListComponent, canActivate: [AuthGuard] },
  { path: 'add', component: CustomersAddComponent, canActivate: [AuthGuard] },
  { path: 'edit/:id', component: CustomersAddComponent, canActivate: [AuthGuard] }
];
 
@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class CustomersRoutingModule {}
